<div class="appo-appointment-request-identification">
  <form #appoAppointmentRequestIdentificationForm="ngForm"
        id="{{formId}}"
        name="{{formId}}">
    <div class="row">
      <div class="col-12 col-sm-auto ml-auto">
        <button class="si-button_main px-2 w-100"
                translate="SI_ALREADY_HAVE_ACCOUNT"
                type="button"
                (click)="onClickLogin()"
        ></button>
      </div>
      <div class="col-12 col-sm mt-2 mt-sm-0 appo-appointment-request-identification_title order-sm-first">
        <span>{{'SI_PERSONAL_DATA' | translate}}</span>
      </div>
      <div class="col-12">
        <si-register-personal-data [(model)]="model"
                                   [validationErrorTextIdentityDocument]="validationErrorTextIdentityDocument"
                                   [wideResolution]="true"
        ></si-register-personal-data>
      </div>
    </div>
    <div class="row">
      <div class="w-100 pasi-line-lightgrey"></div>
      <div class="col-12 appo-appointment-request-identification_title">
        <span>{{'SI_PASSWORD' | translate}}</span>
      </div>
      <div class="col-12">
        <si-register-password [(model)]="model"
                              [wideResolution]="true"
                              [errorText]="passwordErrorText"
        ></si-register-password>
      </div>
    </div>
    <div class="row">
      <div class="w-100 pasi-line-lightgrey"></div>
      <div class="col-12 appo-appointment-request-identification_title">
        <span>{{'SI_PRIVACY_POLICY' | translate}}</span>
      </div>
      <div class="col-12">
        <si-register-privacy [(model)]="model"
                             [wideResolution]="true"
                             (captchaRenderedChange)="onChangeCaptchaRendered($event)"
        ></si-register-privacy>
      </div>
    </div>
  </form>
  <ng-container *ngIf="displayLoginDialog">
    <si-login-dialog [(displayDialog)]="displayLoginDialog"
                     (loginSuccessChange)="onLoginSuccessChange()"
    ></si-login-dialog>
  </ng-container>
</div>
